namespace Ir.Components.Workbook.WorkbookList {
    export interface IWorkbookListViewModel {
        workbooks: Array<SimpleWorkbookVM>;

        listConfig: DevExpress.ui.dxList.Properties;
        listComponent: DevExpress.ui.dxList;
    
        
        buttonConfig: DevExpress.ui.dxButton.Properties;
        emailButtonConfig: DevExpress.ui.dxButton.Properties;
        shareSelected: KnockoutComputed<boolean>;

        refresh: (id: number, newName: string) => void;
    }

    interface IParams {
        onClick: (workbook: SimpleWorkbookVM) => void;
        onFiltering: (workbooks: Array<SimpleWorkbookVM>) => Array<SimpleWorkbookVM>;
        selectionMode: string;
        getEmails: boolean;
        getComponent: (component: IWorkbookListViewModel) => void;
    }

    export function getViewModel(this: IWorkbookListViewModel, params: IParams, componentInfo) {
        let self = this;

        if (params.getEmails === undefined) {
            params.getEmails = false;
        }

        function getDataSource(): Array<SimpleWorkbookVM> {
            let dataSource = self.workbooks;
            if (params.getEmails && filterByEmail) {
                dataSource = dataSource.filter(x => x.hasEmails);
            }

            if (loggedUser.showSharedWorkbooks()) {
                return params.onFiltering(dataSource);
            }

            return params.onFiltering(dataSource.filter(x => x.editMode === WorkbookEditModeEnum.Owner || x.id === workbook.workbookConfig.workbookId()));
        }

        //Uses a store to load the workbooks asynchronously
        const store = new DevExpress.data.CustomStore({
            loadMode: "raw",
            load(loadOptions) {
                if (self.workbooks) {
                    return getDataSource();
                }

                const deferred = $.Deferred();

                let url = `${urlConfigs.siteRoot}wb/GetWorkbooks`;
                let o = {
                    verb: "POST",
                    url: url,
                    data: { getEmails: params.getEmails },
                    dataType: "json",
                    async: true,
                } as RequestServerParams;
                o.successFunction = function (data: any) {
                    self.workbooks = createInstances(SimpleWorkbookVM, data as Array<any>);
                    deferred.resolve(getDataSource());
                }
                o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to get workbooks";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                    deferred.reject('Data Loading Error');
                }
                irGlobal.requestServer(o);

                return deferred.promise();
            },
        });

        this.shareSelected = ko.computed(function () { return loggedUser.showSharedWorkbooks(); });
        this.buttonConfig = {
            hint: 'Show/Hide Shared Workbooks',
            template: `<i class="ms">share</i>`,
            height: 26,
            width: 30,
            onClick(e) {
                loggedUser.showSharedWorkbooks(!loggedUser.showSharedWorkbooks());
                reload(self);

                let o = {
                    url: `${urlConfigs.siteRoot}Home/SaveShowHideWorkbooks`,
                    data: { showSharedWorkbooks: loggedUser.showSharedWorkbooks(), userId: loggedUser.id() },
                    dataType: "json",
                    async: false
                } as RequestServerParams;
                o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to save setting to show or hide shared workbooks";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                };

                irGlobal.requestServer(o);

                self.listComponent.focus();
            }
        };

        let filterByEmail = false;
        this.emailButtonConfig = {
            hint: 'Filter Workbooks by Email',
            template: `<i class="ms">email</i>`,
            height: 26,
            width: 30,
            onClick(e) {
                filterByEmail = !filterByEmail;
                reload(self);

                if (filterByEmail) {
                    e.element.addClass("dx-state-selected");
                }
                else {
                    e.element.removeClass("dx-state-selected");
                }

                self.listComponent.focus();
            },
            visible: params.getEmails
        };

        if (!params.onFiltering) {
            params.onFiltering = (workbooks) => { return workbooks; };
        }

        this.listConfig = {
            dataSource: store,
            keyExpr: 'id',
            displayExpr: 'name',
            searchEnabled: true,
            searchExpr: 'name',
            pageLoadMode: 'scrollBottom',
            selectionMode: params.selectionMode ?? 'single' as any,
            selectedItemKeys: [workbook.workbookConfig.workbookId()],
            activeStateEnabled: false,
            focusStateEnabled: false,
            itemTemplate: function (itemData: SimpleWorkbookVM) {
                let $element = $(`<div class="workbook-list-item"><div class="workbook-list-item-name">${itemData.name} </div></div>`);
                if (itemData.editMode !== WorkbookEditModeEnum.Owner) {
                    let title = loggedUser.permissions.workbooks() ? "" : "Shared&#10;";
                    title += `Owner: ${itemData.ownerUserName}&#10;Email: ${itemData.ownerEmail}`;
                    let $icon = $(`<i class="ms" title="${title}">${(loggedUser.permissions.workbooks() ? "person" : "share")}</i>`).click(function (e) {
                        e.stopPropagation();
                        irGlobal.copyTextToClipboard(itemData.ownerEmail, "Email copied to clipboard");
                    });
                    $element.append($icon);

                    if (!loggedUser.permissions.workbooks()) {
                        if (itemData.editMode === WorkbookEditModeEnum.ViewOnly || itemData.editMode === WorkbookEditModeEnum.Restricted) {
                            let tooltip = itemData.editMode === WorkbookEditModeEnum.Restricted ? "Restricted" : "View Only";
                            let $icon = $(`<i class="ms" title="${tooltip}">${(itemData.editMode === WorkbookEditModeEnum.Restricted ? "visibility_lock" : "visibility")}</i>`);
                            $element.append($icon);
                        }
                    }
                }

                if (itemData.hasEmails) {
                    $element.append('<i class="ms" title="Emails">email</i>');
                }

                return $element;
            }.bind(this),
            onInitialized(e) {
                self.listComponent = e.component;
            },
            
            onSelectionChanged(e) {
                const workbookVM: SimpleWorkbookVM = e.addedItems[0];
                if (!workbookVM || workbookVM.id === workbook.workbookConfig.workbookId()) {
                    return;
                }

                if (params.onClick) {
                    params.onClick(workbookVM);
                    return;
                }

                let url = `${urlConfigs.tabs}edit/${workbookVM.id}`;
                if (workbook.workbookConfig.appBar.multiTenant) {
                    let checkCompany = function () {
                        let o = {
                            url: `${urlConfigs.tabs}GetDifWorkbookCompanyFromCache`,
                            data: { workbookId: workbookVM.id },
                            dataType: "json",
                            async: false
                        } as RequestServerParams;
                        o.successFunction = function (result, e) {
                            if (result.cached) {
                                let customDialog = DevExpress.ui.dialog.custom({
                                    showTitle: false,
                                    messageHtml: `The actual company will be changed to '${result.companyName}' to open the workbook '${result.workbookName}'`,
                                    buttons: [
                                        {
                                            text: `Save the workbook and keep the '${result.currentCompanyName}' company`,
                                            onClick: function () { return "Save"; },
                                        },
                                        { text: "OK", onClick: function () { return "OK"; } },
                                        { text: "Cancel", onClick: function () { return "Cancel"; } }
                                    ]
                                });
                                customDialog.show().done(function (dialogResult) {
                                    if (dialogResult === "Save") {
                                        let o = {
                                            url: `${urlConfigs.tabs}SaveDifWorkbookCompanyFromCache`,
                                            data: { workbookId: workbookVM.id },
                                            dataType: "json",
                                            async: false
                                        } as RequestServerParams;
                                        o.successFunction = function () {
                                            document.location.href = url;
                                        }
                                        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                                            errorItem.userMessage = "Failed to save workbook";
                                            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                                        };
                                        irGlobal.requestServer(o);
                                    }
                                    else if (dialogResult === "OK") {
                                        url += `?companyId=${result.companyId}`;
                                        document.location.href = url;
                                    }
                                    else {
                                        e.component.option("selectedItemKeys", [workbook.workbookConfig.workbookId()]);
                                    }
                                });
                            }
                            else {
                                document.location.href = url;
                            }
                        }.bind(this);
                        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                            errorItem.userMessage = "Failed to check if workbook has changed";
                            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                        };

                        irGlobal.requestServer(o);
                    };

                    if (workbook.workbookConfig.hasPendingChanges) {
                        let customDialog = DevExpress.ui.dialog.custom({
                            showTitle: false,
                            messageHtml: `Are you sure you want to go to ${workbookVM.name}? You have pending changes to your workbook.`,
                            buttons: [
                                { text: "Yes", onClick: function () { return true } },
                                { text: "No", onClick: function () { return false } }
                            ]
                        });
                        customDialog.show().done(function (dialogResult) {
                            if (dialogResult) {
                                checkCompany();
                            }
                            else {
                                e.component.option("selectedItemKeys", [workbook.workbookConfig.workbookId()]);
                            }
                        });
                    }
                    else {
                        checkCompany();
                    }
                }
                else {
                    workbook.workbookConfig.workbookHelper.goToURL(url, workbookVM.name, () => {
                        e.component.option("selectedItemKeys", [workbook.workbookConfig.workbookId()]);
                    });
                }
            },
            onItemClick(e) {
                if (params.selectionMode === "none") {
                    if (params.onClick) {
                        params.onClick(e.itemData);
                    }
                }
            }
        };

        if (params.getEmails) {
            $(componentInfo.element).addClass("showEmails");
        }

        this.refresh = function (id: number, newName: string) {
            let wb = self.workbooks?.find(x => x.id === id);
            if (wb) {
                wb.name = newName;
                self.listComponent.repaint();
            }
        };

        if (params.getComponent) {
            params.getComponent(this);
        }
    }

    function reload(self: IWorkbookListViewModel) {
        //force reload to refresh the list
        self.listComponent.reload();
        //select again the current workbook
        self.listComponent.option("selectedItemKeys", [workbook.workbookConfig.workbookId()]);
    }
}